export interface PassMod {
   
    email: string; 
   
   
}

export class PassMod implements PassMod {
    constructor(init?: PassModFormValues) {
        Object.assign(this, init);
    }
}

export class PassModFormValues {
   
    email: string = "";
   
   
    
    constructor(PassMod?: PassModFormValues) {
        if (PassMod) {
          
            this.email = PassMod.email;
                     
            
        }

    }
}

export interface ResetPassMod {
   
    email: string;
    token: string;
    password: string; 
   
   
}

export class ResetPassMod implements ResetPassMod {
    constructor(init?: ResetPassModFormValues) {
        Object.assign(this, init);
    }
}

export class ResetPassModFormValues {
   
    email: string = "";
    token: string = "";
    password: string = "";
   
   
    
    constructor(ResetPassMod?: ResetPassModFormValues) {
        if (ResetPassMod) {
          
            this.email = ResetPassMod.email;
            this.token = ResetPassMod.token;
            this.password = ResetPassMod.password;
                     
            
        }

    }
}